import script from "./header.vue?vue&type=script&setup=true&lang=js"
export * from "./header.vue?vue&type=script&setup=true&lang=js"

import "./header.vue?vue&type=style&index=0&id=3a628801&lang=css"
import "./header.vue?vue&type=style&index=1&id=3a628801&lang=scss&scoped=true"
import "./header.vue?vue&type=style&index=2&id=3a628801&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a628801"]])

export default __exports__